import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const wineGeographicIndicationsSchema: CollectionCreateSchema = {
  name: CollectionName.WineGeographicIndications,
  fields: [
    {
      name: "search_id",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
